import * as React from 'react'
import Select from 'react-select'
import ServiceProvider from '../../../containers/services/ServiceProvider'
import { IProviderObject } from '../../../types/index'

interface IServiceProvidersProps {
  serviceId: string
  serviceProductsIds: string[]
  onSelectProvider: (providerId: string, serviceId: string) => void
  onUpdateProviders: (serviceId: string, serviceProductsIds: string[]) => Promise<any>
  onStepSuccessfullyCompleted?: () => void
  formRef: any
}

interface IServiceProviderState {
  showAddProviderControl: boolean
}

class ServiceProviders extends React.Component<IServiceProvidersProps, IServiceProviderState> {
  constructor(props: IServiceProvidersProps) {
    super(props)
    this.state = {
      showAddProviderControl: false
    }
  }

  public render() {
    return (
      <div className='pl2 col-8 mb3'>
        <div ref={this.props.formRef} onClick={this.handleSubmit} />
        <div className='font-dark-grey mt3'>Products</div>
      </div>
    )
  }

  private handleSubmit = () => {
    this.props
      .onUpdateProviders(this.props.serviceId, this.props.serviceProductsIds)
      .then(() => this.props.onStepSuccessfullyCompleted && this.props.onStepSuccessfullyCompleted())
  }

  private handleAddProviderClick = () => {
    this.setState({ ...this.state, showAddProviderControl: true })
  }

  private handleProviderSelect = (option: any) => {
    if (!option) {
      return
    }
    this.props.onSelectProvider(option.value, this.props.serviceId)
    this.setState({ ...this.state, showAddProviderControl: false })
  }
}

const ProviderListHeader = () => (
  <div className='flex flex-row bb-light-grey4 pb1'>
    <div className='col-5 font-light-grey'>Providers</div>
    <div className='col-7 font-light-grey'>Products</div>
  </div>
)

export default ServiceProviders



// WEBPACK FOOTER //
// ./src/components/services/edit/ServiceProviders.tsx